import { createSlice } from '@reduxjs/toolkit';

export const defaultState = {
  activeModal: ''
};

const layoutSlice = createSlice({
  initialState: defaultState,
  name: 'layout',
  reducers: {
    toggleActiveModal: (state, { payload }) => {
      state.activeModal = payload;
    },
  }
});

export const {
  toggleActiveModal
} = layoutSlice.actions;

export default layoutSlice.reducer;